// app/javascript/controllers/tio_lines_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["productCodeField", "dealIdField", "priceField", "uomField"]
  static values = {
    tioId: String
  }

  productSelected(event) {
    const tio_id     = this.tioIdValue
    const product_id = event.target.value
    
    this.fetchProductCode(tio_id, product_id)
    this.fetchProductDeal(tio_id, product_id)
  }

  fetchProductCode(tio_id, product_id) {
    if (!product_id || product_id === '') {
      this.productCodeFieldTarget.value = '';
      return;
    }

    const url = `/tios/${tio_id}/tio_line_stocks?product_id=${product_id}`

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        this.productCodeFieldTarget.value = data.product_code ?? '';
      })
      .catch(error => {
        console.error('Error fetching product code:', error);
        this.productCodeFieldTarget.value = '';
      })
  }

  fetchProductDeal(tio_id, product_id) {
    if (!product_id || product_id === '') {
      this.dealIdFieldTarget.value = '';
      this.priceFieldTarget.value = '';
      this.uomFieldTarget.value = '';
      return;
    }

    const url = `/tios/${tio_id}/tio_line_offers?product_id=${product_id}&offerable_type=Deal`

    fetch(url, {
      method: 'GET',
      headers: {
        'Accept': 'application/json'
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        const offer = data.offer || {};
        this.dealIdFieldTarget.value = offer.id ?? '';
        this.priceFieldTarget.value = offer.price ?? '';
        this.uomFieldTarget.value = offer.uom ?? '';
      })
      .catch(error => {
        console.error('Error fetching product deal:', error);
        this.dealIdFieldTarget.value = '';
        this.priceFieldTarget.value = '';
        this.uomFieldTarget.value = '';
      })
  }
}